import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DnBtnComponent } from './dn-btn.component';

@NgModule({
  declarations: [DnBtnComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DnBtnComponent],
})
export class DnBtnModule {}
